import { ShoppingCart } from "lucide-react";
import { Link } from "react-router-dom";

export const CreditBalanceUpgradeView = () => {
  return (
    <Link
      to="/subscription"
      className="group relative flex items-center transition-all active:scale-press"
    >
      <div className="flex cursor-pointer items-center gap-3 rounded-full border border-primary-border bg-primary-subtle px-4 py-1.5 shadow-sm transition-all hover:border-primary-border hover:bg-primary-subtle-hover">
        <div className="rounded-full bg-primary-subtle-hover p-1 group-hover:bg-primary-border">
          <ShoppingCart size={14} className="text-primary" />
        </div>

        <div className="flex items-center">
          <span className="text-sm font-bold text-primary">Upgrade</span>
        </div>
      </div>
    </Link>
  );
};
